import { makeAutoObservable, runInAction } from 'mobx';
import { ChatComment } from '../models/comments';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { store } from './store';

class CommentStore {
  comments: ChatComment[] = [];
  hubConnection: HubConnection | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  createHubConnection = (activityId: string) => {
    if (store.activityStore.selectedActivity) {
      this.hubConnection = new HubConnectionBuilder()
        .withUrl(process.env.REACT_APP_CHAT_URL + '?activityId=' + activityId, {
          accessTokenFactory: () => {
            if (!store.userStore.user) throw new Error('Userstore has no user');
            return store.userStore.user.token;
          },
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Information)
        .build();

      this.hubConnection
        .start()
        .catch((error) =>
          console.error('Error establishing connection: ', error),
        );

      this.hubConnection.on('LoadComments', (comments: ChatComment[]) => {
        runInAction(() => {
          this.comments = comments.map((comment) => ({
            ...comment,
            createdAt: new Date(comment.createdAt),
          }));
        });
      });

      this.hubConnection.on('ReceiveComment', (comment: ChatComment) => {
        runInAction(() => {
          this.comments.unshift({
            ...comment,
            createdAt: new Date(comment.createdAt),
          });
        });
      });
    }
  };

  stopHubConnection = () => {
    this.hubConnection
      ?.stop()
      .catch((error) => console.error('Error stopping connection: ', error));
  };

  clearComments = () => {
    this.comments = [];
    this.stopHubConnection();
  };

  addComment = async (values: any) => {
    values.activityId = store.activityStore.selectedActivity?.id;
    try {
      this.hubConnection?.invoke('SendComment', values);
    } catch (error) {
      console.error(error);
    }
  };
}

export { CommentStore };
